import { useTranslation } from 'react-i18next'
import { Row, Col, Typography } from 'antd'
import { Img, ListItems } from '../common'
import Tile from '../Tile'
const { Title, Paragraph } = Typography

const NumberTile = ({ number, title, img }) => {
  return (
    <Col>
      <Tile className="small">
        <Title level={2} className="number">
          {number + '.'}
        </Title>
        <Paragraph className="paragraph-sb">{title}</Paragraph>
        <Img src={'images/login/' + img} alt={title} />
      </Tile>
    </Col>
  )
}
export const HowItWorks = () => {
  const { t } = useTranslation()
  return (
    <>
      <Title>{t('Login.HowItWorks')}</Title>
      <Row className="tiles stretch" gutter={[0, 15]} justify="space-between">
        <NumberTile
          number={1}
          title={t('Login.UploadText')}
          img="grin_illu_sf_01_upload.svg"
        />
        <NumberTile
          number={2}
          title={t('Login.ChooseOption')}
          img="grin_illu_sf_03_option.svg"
        />
        <NumberTile
          number={3}
          title={t('Login.InformationPublication')}
          img="grin_illu_sf_02_detail.svg"
        />

        <Col>
          <Tile className="small free">
            <Title level={2}>
              <strong>{t('Login.DonePublication')}</strong>
            </Title>
            <Paragraph className="paragraph-sb">
              {t('Login.FreeEarn')}
            </Paragraph>
            <Img
              src="https://www.grin.com/wp-content/uploads/2020/08/ico_grin_white.svg"
              alt="Grin smile"
            />
          </Tile>
        </Col>
      </Row>
      <Title style={{ paddingTop: '50px' }} level={3}>
        {t('Login.Advantages')}
      </Title>
      <ListItems namePrefix={'Login.Advantage'} size={5} />
    </>
  )
}

export default HowItWorks
